/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskDistributableAmount
 */
export interface ExecRiskDistributableAmount {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributableAmount
     */
    CYAdjNetIncomeDistributableAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributableAmount
     */
    CYPct85AdjustedNetIncomeAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributableAmount
     */
    CYTotalMinAstDistributableAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributableAmount
     */
    CYGreaterAdjustedMinimumAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributableAmount
     */
    CYIncomeTaxImposedPYAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributableAmount
     */
    CYDistributableAsAdjustedAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskDistributableAmount
     */
    FirstYearType3NonFuncInd?: string;
}

/**
 * Check if a given object implements the ExecRiskDistributableAmount interface.
 */
export function instanceOfExecRiskDistributableAmount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskDistributableAmountFromJSON(json: any): ExecRiskDistributableAmount {
    return ExecRiskDistributableAmountFromJSONTyped(json, false);
}

export function ExecRiskDistributableAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskDistributableAmount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'CYAdjNetIncomeDistributableAmt': !exists(json, 'CYAdjNetIncomeDistributableAmt') ? undefined : json['CYAdjNetIncomeDistributableAmt'],
        'CYPct85AdjustedNetIncomeAmt': !exists(json, 'CYPct85AdjustedNetIncomeAmt') ? undefined : json['CYPct85AdjustedNetIncomeAmt'],
        'CYTotalMinAstDistributableAmt': !exists(json, 'CYTotalMinAstDistributableAmt') ? undefined : json['CYTotalMinAstDistributableAmt'],
        'CYGreaterAdjustedMinimumAmt': !exists(json, 'CYGreaterAdjustedMinimumAmt') ? undefined : json['CYGreaterAdjustedMinimumAmt'],
        'CYIncomeTaxImposedPYAmt': !exists(json, 'CYIncomeTaxImposedPYAmt') ? undefined : json['CYIncomeTaxImposedPYAmt'],
        'CYDistributableAsAdjustedAmt': !exists(json, 'CYDistributableAsAdjustedAmt') ? undefined : json['CYDistributableAsAdjustedAmt'],
        'FirstYearType3NonFuncInd': !exists(json, 'FirstYearType3NonFuncInd') ? undefined : json['FirstYearType3NonFuncInd'],
    };
}

export function ExecRiskDistributableAmountToJSON(value?: ExecRiskDistributableAmount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CYAdjNetIncomeDistributableAmt': value.CYAdjNetIncomeDistributableAmt,
        'CYPct85AdjustedNetIncomeAmt': value.CYPct85AdjustedNetIncomeAmt,
        'CYTotalMinAstDistributableAmt': value.CYTotalMinAstDistributableAmt,
        'CYGreaterAdjustedMinimumAmt': value.CYGreaterAdjustedMinimumAmt,
        'CYIncomeTaxImposedPYAmt': value.CYIncomeTaxImposedPYAmt,
        'CYDistributableAsAdjustedAmt': value.CYDistributableAsAdjustedAmt,
        'FirstYearType3NonFuncInd': value.FirstYearType3NonFuncInd,
    };
}

